// extracted by mini-css-extract-plugin
module.exports = {"root":"LeftSection_root__BvjAv","fixed":"LeftSection_fixed__25g9E"};